export default {
  0: "我们同时拥有内、外部身份管理平台，能提供最适合你的企业的产品和价格。",
  1: "客服时间：工作日 9:00-19:00",
  2: "客服时间：7*24 小时",
  3: "Authing 短信服务场景有注册、登录、登录异常、忘记密码、信息变更、支付确认、活动确认等。拥有专线机房，支持大容量、高并发，最大秒发送量 10 万。并拥有独家真机监控，实时监控自动切换。",
  4: "一账户双通道运营，智能切换短信通道，保证短信发送不间断",
  5: "联手三大运营商，三网短信通道落地，还支持虚拟运营商号段",
  6: "企业实名制独享短信接口，短信发送流速达 800 条/秒",
  7: "99.99% 短信验证码到达率",
  8: "想了解更多关于企业版的定价信息？",
  9: "请填写你的联系方式，很快我们的技术专家将会与你取得联系，为你解决你遇到的问题。",
  10: "有需要咨询的问题请在备注中简述",
  11: "统一认证平台、统一登录、单点登录价格 - 身份云是什么",
  用户身份管理: "用户身份管理",
  免费服务: "免费服务：",
  免费8000次认证次数: "免费 8000 次认证次数",
  统一认证云: "统一认证云",
  用户管理: "用户管理",
  多因素认证: "多因素认证",
  集成主流登录方式: "集成主流登录方式",
  在线技术文档: "在线技术文档",
  免费使用: "立即试用",
  增值服务: "增值服务：",
  定制开发私有部署: "定制开发 & 私有部署",
  更高级别安全管理: "更高级别安全管理",
  开发技术支持: "开发技术支持",
  个性化产品培训: "个性化产品培训",
  咨询顾问: "咨询顾问",
  员工身份管理: "员工身份管理",
  免费10人团队: "免费 10 人团队",
  单点登录: "单点登录",
  统一认证源: "统一认证源",
  集中授权: "集中授权",
  应用管理: "应用管理",
  日志审计: "日志审计",
  企业咨询: "企业咨询",
  Authing短信服务的优势: "Authing 短信服务的优势：",
  多通道备份: "多通道备份",
  三网合一: "三网合一",
  独立端口: "独立端口",
  到达率: "到达率",
  Authing短信包套餐: "Authing 短信包套餐",
  条: "条",
  平均每条短信01元: "平均每条短信 0.1 元",
  平均每条短信005元: "平均每条短信 0.05 元",
  价格咨询请联系我们: "价格咨询请联系我们",
  联系销售: "联系销售",
  称呼: "称呼",
  我们的顾问将在三日内致电你: "我们的顾问将在三日内致电你",
  手机号: "手机号",
  公司名: "公司名",
  备注信息: "备注信息",
  提交: "提交",
  请输入你的姓名: "请输入你的姓名",
  请输入你的手机号: "请输入你的手机号",
  请输入合法的手机号: "请输入合法的手机号",
  请输入你的公司名: "请输入你的公司名",
  提交成功: "提交成功",
  activeUser: "活跃用户数",
  customizable: "可定制",
};
